<p-toast></p-toast>

<p-overlayPanel #op [dismissable]="true" [showCloseIcon]="true">
  <div>
    <app-prod-group-tree [groupId]="selectedGroupId" [reloadTree]="reloadTree" (selectedGroup)="onSelectedGroup($event)"></app-prod-group-tree>
  </div>
</p-overlayPanel>

<app-products-search #prodSearch [(display)]="displayPS" [searchText]="searchtext" (selectedProduct)="onProductSelection($event)"></app-products-search>

<app-prodgroup-search [(display)]="displayMoveGroup" [groupId]="selectedGroupId" (selectedGroup)="onMoveGroupConfirm($event)" closeOnSelection="false"></app-prodgroup-search>

<app-rename-something-dialog [(display)]="displayRenameGroup" header="Переименование группы" [textToRename]="groupName" (onRename)="onRenameGroupConfirm($event)"></app-rename-something-dialog>

<app-rename-something-dialog [(display)]="displayCreateGroup" header="Создание группы" [textToRename]="newGroupName" (onRename)="onCreateGroupConfirm($event)"></app-rename-something-dialog>

<app-import-product-info-dlg [(display)]="doProductImport" [newProductTemplate]="selectedProduct" (importIsDone)="importIsDone($event)"></app-import-product-info-dlg>

<p-toolbar #toolBar styleClass="">

  <div class="p-toolbar-group-left">
    <p-button label="Группы товаров" icon="pi pi-site" styleClass="p-button-help mr-2" (onClick)="op.toggle($event)"></p-button>

    <p-splitButton label="Создать новую группу..." icon="pi pi-folder" [model]="items" styleClass="p-button-help mr-2" menuStyleClass="p-button-help"
                   (onClick)="onCreateNewGroup($event)" [disabled]="!selectedGroup"
                   pTooltip="Создать новую группу товаров" tooltipPosition="top"></p-splitButton>

    <p-button icon="pi pi-sitemap" styleClass="p-button-help mr-2" (onClick)="goToProductGroup($event)" [disabled]="!onParentGroup"
              pTooltip="Открыть группу товара" tooltipPosition="top"></p-button>

    <p-button label="Создать" icon="pi pi-plus" styleClass="p-button-success mr-2" (onClick)="doNewProduct(selectedProduct)" pTooltip="Новый товар" tooltipPosition="top"></p-button>

    <p-button label="Скопировать" icon="pi pi-copy" styleClass="p-button-success mr-2" (onClick)="doCopyProduct(selectedProduct)" [disabled]="ifThereNoSelection"
              pTooltip="Новый товар на основе выбранного" tooltipPosition="top"></p-button>

    <p-button label="Импортировать товары" icon="pi pi-download" styleClass="p-button-help mr-2" (onClick)="doProductImport=true" [disabled]="ifThereNoSelection"
              pTooltip="Импортировать товары или обновить существующие из буфера/файла" tooltipPosition="top"></p-button>

    <p-button icon="pi pi-trash" styleClass="p-button-danger mr-2" (onClick)="doDeleteProduct(selectedProduct)" [disabled]="ifThereNoSelection"
              pTooltip="Удалить выбранный товар" tooltipPosition="top"></p-button>
  </div>

  <div class="p-toolbar-group-right justify-content-end flex">

    <div class="p-inputgroup mr-2">
      <input type="text" pInputText [(ngModel)]="searchtext" placeholder="Найти товар" (keyup.enter)="searchProduct($event)">
      <p-button label="Найти" styleClass="p-button-success" (onClick)="searchProduct($event)"></p-button>
    </div>

    <p-button icon="pi pi-tag" styleClass="p-button-secondary mr-2" (onClick)="markBookmark1($event)" [disabled]="ifThereNoSelection"
              [badge]="isThereBookmark1 ? 1 : 0" badgeClass="isThereBookmark1 ? 'p-badge-info' : ''" [pTooltip]="bookmarkText1" tooltipPosition="top"></p-button>
    <p-button icon="pi pi-tag" styleClass="p-button-secondary mr-2" (onClick)="markBookmark2($event)" [disabled]="ifThereNoSelection"
              [badge]="isThereBookmark2 ? 2 : 0" badgeClass="isThereBookmark2 ? 'p-badge-info' : ''" [pTooltip]="bookmarkText2" tooltipPosition="top"></p-button>
    <p-button icon="pi pi-tag" styleClass="p-button-secondary mr-2" (onClick)="markBookmark3($event)" [disabled]="ifThereNoSelection"
              [badge]="isThereBookmark3 ? 3 : 0" badgeClass="isThereBookmark3 ? 'p-badge-info' : ''" [pTooltip]="bookmarkText3" tooltipPosition="top"></p-button>

    <p-button icon="pi pi-refresh" styleClass="p-button-success mr-2" (onClick)="onReloadAllData($event)" pTooltip="Обновить список товаров" tooltipPosition="top"></p-button>

    <p-splitButton label="XLSX" icon="pi pi-file-excel" [model]="excelExportItems" styleClass="p-button-info hide-label mr-2"
                   [disabled]="disableExportButton" (onDropdownClick)="checkCommand($event)" (onClick)="exportExcel()"
                   pTooltip="Экспортировать список товаров в MS Excel формате" tooltipPosition="top"></p-splitButton>

    <!--<p-button label="XLSX" icon="pi pi-file-excel" styleClass="p-button-info mr-2" (onClick)="exportExcel()" pTooltip="Экспортировать список товаров в MS Excel формате" tooltipPosition="top" [disabled]="!canExport"></p-button>-->
    <!--    <p-button label="PDF" icon="pi pi-file-pdf" styleClass="p-button-info" (onClick)="exportPdf()" pTooltip="Экспортировать список товаров в PDF формате" tooltipPosition="top" [disabled]="!canExport"></p-button>-->
  </div>
</p-toolbar>
<app-product-list #prodlist [groupId]="selectedGroupId" [prodId]="selectedProdId" [usdCurrencyId]="usdCurrencyId"
                  (usdCurrencyIdChange)="onCurrencyChange($event)"
                  (productSelection)="onProductListSelection($event)"
                  (contentReady)="contentReady=$event"
                  (allProductList)="allProductList=$event"></app-product-list>
